/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './players.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../app/+tournament/players/players.component';
import * as import3 from '@angular/forms';
import * as import4 from '@angular/common';
import * as import5 from '@ngrx/store/src/store';
const styles_PlayersComponent:any[] = [import0.styles];
export const RenderType_PlayersComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_PlayersComponent,
  data: {}
}
);
function View_PlayersComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'no-players'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['No players yet.']))
  ]
  ,(null as any),(null as any));
}
function View_PlayersComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n      ',
      '\n      '
    ]
    )),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'button',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.remove(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',[[
        'class',
        'material-icons'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['delete'])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,1,0,currVal_0);
  });
}
export function View_PlayersComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(2,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'warn'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  Any change will reset the tournament\n'])),
    (l()(),import1.ɵted((null as any),['\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'align'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Add player'])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'form'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'input',[[
        'type',
        'text'
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'keyup.enter'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.PlayersComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,11)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,11).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,11)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,11)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.name = $event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('keyup.enter' === en)) {
        co.add(co.name);
        const pd_5:any = ((<any>(co.name = '')) !== false);
        ad = (pd_5 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(8192,(null as any),0,import3.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import3.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(512,(null as any),import3.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import3.DefaultValueAccessor]),
    import1.ɵdid(335872,(null as any),0,import3.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import3.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import1.ɵprd(1024,(null as any),import3.NgControl,(null as any),[import3.NgModel]),
    import1.ɵdid(8192,(null as any),0,import3.NgControlStatus,[import3.NgControl],(null as any),(null as any)),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',([] as any[]),[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.PlayersComponent = v.component;
      if (('click' === en)) {
        co.add(co.name);
        const pd_0:any = ((<any>(co.name = '')) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Add'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Players'])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_PlayersComponent_1)),
    import1.ɵdid(8192,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(65536,import4.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_PlayersComponent_2)),
    import1.ɵdid(401408,(null as any),0,import4.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
    ,{
      ngForOf: [
        0,
        'ngForOf'
      ]
      ,
      ngForTrackBy: [
        1,
        'ngForTrackBy'
      ]

    }
    ,(null as any)),
    import1.ɵpid(65536,import4.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import2.PlayersComponent = v.component;
    const currVal_7:any = co.name;
    ck(v,13,0,currVal_7);
    var tmp_9_0:any = (null as any);
    const currVal_9:boolean = !(((tmp_9_0 = import1.ɵunv(v,26,0,import1.ɵnov(v,27).transform(co.players))) == null)? (null as any): tmp_9_0.length);
    ck(v,26,0,currVal_9);
    const currVal_10:any = import1.ɵunv(v,30,0,import1.ɵnov(v,31).transform(co.players));
    const currVal_11:any = co.trackById;
    ck(v,30,0,currVal_10,currVal_11);
  },(ck,v) => {
    var co:import2.PlayersComponent = v.component;
    const currVal_0:any = import1.ɵnov(v,15).ngClassUntouched;
    const currVal_1:any = import1.ɵnov(v,15).ngClassTouched;
    const currVal_2:any = import1.ɵnov(v,15).ngClassPristine;
    const currVal_3:any = import1.ɵnov(v,15).ngClassDirty;
    const currVal_4:any = import1.ɵnov(v,15).ngClassValid;
    const currVal_5:any = import1.ɵnov(v,15).ngClassInvalid;
    const currVal_6:any = import1.ɵnov(v,15).ngClassPending;
    ck(v,10,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:boolean = !((co.name == null)? (null as any): co.name.length);
    ck(v,16,0,currVal_8);
  });
}
function View_PlayersComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'ept-players',([] as any[]),(null as any),(null as any),(null as any),View_PlayersComponent_0,RenderType_PlayersComponent)),
    import1.ɵdid(57344,(null as any),0,import2.PlayersComponent,[import5.Store],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PlayersComponentNgFactory:import1.ComponentFactory<import2.PlayersComponent> = import1.ɵccf('ept-players',import2.PlayersComponent,View_PlayersComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/+tournament/players/players.component.ngfactory.ts